import { render, staticRenderFns } from "./UnuseViewSidebar.vue?vue&type=template&id=0c037f90&scoped=true&"
import script from "./UnuseViewSidebar.vue?vue&type=script&lang=js&"
export * from "./UnuseViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UnuseViewSidebar.vue?vue&type=style&index=0&id=0c037f90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c037f90",
  null
  
)

export default component.exports